/**
 * @fileoverview DELETE handler for the "/companies/workspace_rate_limits" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { companiesWorkspaceRateLimitsDeleteCacheKeys } from "./constants";
import type { DeleteCompaniesWorkspaceRateLimitsDeleteProps, DeleteWorkspaceRateLimitErrors } from "./types";

export const deleteCompaniesWorkspaceRateLimitsDelete = reactQueryMutationAdapter(
  companiesWorkspaceRateLimitsDeleteCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeleteWorkspaceRateLimitErrors>()(
    (props: DeleteCompaniesWorkspaceRateLimitsDeleteProps): Promise<void> => {
      // manipulate props here as needed { api_type, endpoint, allocation_id }

      return fetch(
        `/companies/workspace_rate_limits/${props.appGroupId}`,
        "DELETE",
        {
          api_type: props.apiType,
          endpoint: props.endpoint,
          allocation_id: props.allocationId,
        },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
